package navigation.home.send_message

import androidx.compose.runtime.*
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.core.screen.ScreenKey
import cafe.adriel.voyager.koin.koinScreenModel
import com.essntl.core.utils.utils.windowmanager.WindowManager
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.ui.edit_itinerary.MessageSendType
import com.essntl.features.itinerary.ui.send_message.SendMessageEvent
import com.essntl.features.itinerary.ui.send_message.SendMessageScreen
import kotlinx.coroutines.launch
import org.koin.compose.koinInject

class SendMessageScreenNav(
    private val itineraryId: String = "",
    private val itineraryServiceId: String = "",
    private val itineraryServices: List<ItineraryServiceModel> = emptyList(),
    private val type: MessageSendType,
    private val toExpand: Boolean = true,
    private val onSuccessMessage: () -> Unit = {},
) : Screen {

    override val key: ScreenKey = "SendMessageScreenNav/$itineraryId/$itineraryServiceId/${type.name}/$toExpand"

    @Composable
    override fun Content() {
        val sendMessageScreenModel = koinScreenModel<SendMessageScreenModel>()
        val sendMessageState by sendMessageScreenModel.state.collectAsState()

        val scope = rememberCoroutineScope()
        val windowManager = koinInject<WindowManager>()

        LaunchedEffect(Unit) {
            sendMessageScreenModel.onEvent(
                SendMessageEvent.GetItinerary(itineraryId),
            )

            sendMessageScreenModel.onEvent(
                SendMessageEvent.GetItineraryServices(
                    itineraryServiceId,
                    itineraryServices,
                ),
            )

            sendMessageScreenModel.onEvent(
                SendMessageEvent.GetEmails,
            )
        }

        LaunchedEffect(sendMessageState.sendMessageList.isSuccess) {
            if (sendMessageState.sendMessageList.isSuccess)
                onSuccessMessage()
        }

        SendMessageScreen(
            state = sendMessageState,
            onEvent = sendMessageScreenModel::onEvent,
            type = type,
            toExpand = toExpand,
            onExpandScreen = {
                scope.launch {
                    windowManager.emitScreen(
                        SendMessageScreenNav(
                            itineraryId = itineraryId,
                            itineraryServiceId = itineraryServiceId,
                            itineraryServices = itineraryServices,
                            type = type,
                            toExpand = false,
                        ),
                    )
                }
            },
        )
    }
}